module.exports = __webpack_public_path__ + "assets/media/favicon96.70a4ab50379b7ee0067251be2ae90391.png";